module.exports = __webpack_public_path__ + "img/source-search_type-search.976b0558.svg";